import React from 'react';
import { ChevronLeft } from 'lucide-react';
import NotificationBellButton from './NotificationBellButton';
import { HostBottomNav } from './HostBottomNav';
import { useBackTarget } from '../hooks/useBackTarget';

export const HostSettingsLayout = ({
  title,
  children,
  showBell = true,
  showBottomNav = false,
  onBack,
  dataTestId,
}) => {
  const goBack = useBackTarget();

  return (
    <div className="app-shell" data-testid={dataTestId} style={{ minHeight: '100vh', backgroundColor: 'var(--app-bg)', paddingBottom: showBottomNav ? 120 : 40 }}>
      <div style={{ padding: '16px 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button
          onClick={onBack || goBack}
          data-testid={`${dataTestId}-back-button`}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, color: 'var(--text)' }}
        >
          <ChevronLeft size={32} color="currentColor" strokeWidth={1.7} />
        </button>
        {showBell ? (
          <NotificationBellButton buttonTestId={`${dataTestId}-bell-button`} popupTestId={`${dataTestId}-notification-popup`} />
        ) : <div style={{ width: 32, height: 32 }} />}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 16px' }}>
        <img src="/allure-logo.png" alt="Allure" style={{ width: 150, height: 130, objectFit: 'contain', marginTop: 10 }} />
        <h1 style={{ fontFamily: "'Inria Serif', serif", fontSize: 24, fontWeight: 700, color: 'var(--text)', textAlign: 'center', margin: '18px 0 24px', lineHeight: 1.15 }}>{title}</h1>
        <div style={{ width: '100%', maxWidth: 360, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {children}
        </div>
      </div>

      {showBottomNav && <HostBottomNav />}
    </div>
  );
};